import { Button } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useEInvoicingSetup } from '../../hooks/useEInvoicingSetup'

interface EInvoicingCerfaDownloadButtonProps {
  onClick?: () => void
}

export const EInvoicingCerfaDownloadButton = ({
  onClick,
}: EInvoicingCerfaDownloadButtonProps = {}): ReactElement | null => {
  const { t } = useTranslation()
  const { kycCerfaDocument, isUserAuthorizedForKYC } = useEInvoicingSetup()

  const isCerfaDownloadable = kycCerfaDocument && isUserAuthorizedForKYC

  if (!isCerfaDownloadable) {
    return null
  }

  return (
    <Button variant="text" icon="download" href={kycCerfaDocument.signedUrl} onClick={onClick}>
      {t('e_invoice.download_cerfa')}
    </Button>
  )
}
